import db from "../../../database";
import { message, Modal } from "antd";
import i18next from "i18next";
import NotFoundImg from "../../../assets/images/NotFoundImg.svg";
import { productPriceOnScan } from "../../../services/generic";
import { getEstimates, syncSingleProductByValue } from "../../../services";
import messages from "../../../errors/messages.en-IN.json";
import { stock } from "./stock";
import { v4 as uuidv4 } from "uuid";
import { getApplicablePrice } from "../../../utility/getPriceList";

export const barcodeScaner = async (
  data,
  tillData,
  tillLayout,
  addDefinedProduct,
  setBatchSetAvailable,
  setDisplayBatchSelection,
  setLayoutType,
  setIsProductsVisible,
  setProductsData,
  chackBarcodeFlag,
  setSelectedProductInCart,
  setProductSearchInput,
  productSearchInputRef,
  cart,
  authHeaders,
  setOptions,
  fetchOnlineBatches,
  setCart,
  setProductStock,
  setTempCart,
  setShowCompleteSaleStock,
  setCompleteSaleStockData,
  setShowPaymentMethods
) => {
  const t = i18next.t;
  try {
    // Early return if no data is provided
    if (!data) {
      console.error("No QR code data provided");
      return;
    }

    const isRFID = data.startsWith("RFID_"); // Example: Add a prefix check if RFID codes have a specific format
    if (isRFID) {
      return rfidScaner(
        data,
        tillData,
        tillLayout,
        addDefinedProduct,
        setBatchSetAvailable,
        setDisplayBatchSelection,
        setLayoutType,
        setIsProductsVisible,
        setProductsData,
        chackBarcodeFlag,
        setSelectedProductInCart,
        setProductSearchInput,
        productSearchInputRef,
        cart,
        authHeaders,
        setOptions,
        fetchOnlineBatches
      );
    }

    const shouldUseConfig = tillData?.posScanConfigs?.length > 0 && !chackBarcodeFlag;

    // Split data if a delimiter is configured
    let productsToProcess = [data]; // Default to single barcode/QR code
    if (shouldUseConfig) {
      const posConfig = tillData.posScanConfigs.filter((item) => item.formula !== null && item.scanTrxType === "PR");
      const posConfigItem = posConfig.filter((item) => data.startsWith(item.startsWith));
      const qrConfigItem = tillData.posScanConfigs.filter((item) => item.qrCode === "Y" && item.barcodeLength === data?.length);

      if (posConfigItem?.length > 0) {
        const config = posConfigItem[0];
        if (config.delimiter) {
          productsToProcess = data
            .split(config.delimiter)
            .filter(Boolean)
            .map((p) => p.trim());
        }
      } else if (qrConfigItem?.length > 0) {
        const bunitId = tillData?.tillAccess?.csBunit?.csBunitId;
        const response = await getEstimates({
          bunitId: bunitId,
          recordId: data,
          status: "PE",
          startRow: "0",
          endRow: "5",
          date: "",
          documentno: "",
        });
        if (response?.status === 200) {
          const data = JSON.parse(response?.data?.data?.getEstimates || "[]");
          if (data.estimates?.length > 0) {
            const record = data.estimates[0];
            const tillDocumentSequence = parseFloat(localStorage.getItem("documentSequence"));
            const documentno = `${tillData.tillAccess.cwrTill.prefix}${tillDocumentSequence + 1}`;
            const cartData = JSON.parse(record.estimate_json || "{}");
            cartData.estimateId = record?.s_estimate_id;
            cartData.documentno = documentno;
            cartData.tillName = JSON.parse(localStorage.getItem("tillValue"))?.name;
            if (record?.is_advanceorder === "Y") {
              cartData.layAway = "Y";
            }

            let stockCheckResult = true;
            let isFinalValidation = false;
            if (navigator.onLine && tillData?.tillAccess?.csBunit?.allowNegativeStock !== "Y") {
              stockCheckResult = await stock({
                cart: cartData,
                setCart,
                tillData,
                setProductStock,
                isFinalValidation,
                setTempCart,
                isCompleteSale: true,
                setShowCompleteSaleStock,
                setCompleteSaleStockData,
              });
              if (!stockCheckResult) {
                return;
              } else {
                setShowPaymentMethods(true);
              }
            } else {
              setShowPaymentMethods(true);
            }
            setCart(cartData);
            localStorage.setItem("cartObj", JSON.stringify(cartData));
            return;
          } else {
            message.warning(`The scanned estimate is no longer valid.`);
            return;
          }
        } else {
          message.warning("Something is wrong in get estimates service");
        }
      } else {
        console.log("No matching posScanConfig found for QR :", data);
      }
    } else {
      console.log("No posScanConfigs available, using standard product search");
    }

    for (const productData of productsToProcess) {
      if (shouldUseConfig) {
        await barcodeScanFromConfig(
          productData,
          tillData,
          tillLayout,
          addDefinedProduct,
          setBatchSetAvailable,
          setDisplayBatchSelection,
          setLayoutType,
          setIsProductsVisible,
          setProductsData,
          setSelectedProductInCart,
          setProductSearchInput,
          productSearchInputRef,
          authHeaders,
          setOptions,
          fetchOnlineBatches
        );
      } else {
        // Standard product search
        const posConfig = JSON.parse(localStorage.getItem("posConfig"));
        const search = productData.toLowerCase();
        let products;

        if (posConfig?.is_smart_product_search === "Y") {
          products = await db.products
            .filter((product) => product.isactive === true)
            .filter((product) => product.productSegment !== "BG")
            .filter((product) => product.value === productData)
            .limit(100)
            .toArray();

          if (products.length === 0) {
            products = await db.products
              .filter((product) => product.isactive === true)
              .filter((product) => product.productSegment !== "BG")
              .filter((product) => {
                return product.upcIndex === productData || product.upc === productData || product.name?.toLowerCase().includes(search) || product.value === productData;
              })
              .limit(100)
              .toArray();
          }
        } else {
          // products = await db.products
          //   .filter((product) => product.isactive === true)
          //   .filter((product) => product.productSegment !== "BG")
          //   .filter((product) => {
          //     return product.name?.toLowerCase().includes(search) || product.upcIndex === productData || product.upc === productData || product.value === productData;
          //   })
          //   .limit(100)
          //   .toArray();
          const normalizedSearch = search?.toLowerCase().trim();
          const normalizedProductData = productData?.toString().trim();

          products = await db.products
            .filter((product) => product.isactive === true)
            .filter((product) => product.productSegment !== "BG")
            .filter((product) => {
              const name = product.name?.toLowerCase().trim();
              const upcIndex = product.upcIndex?.toString().trim();
              const upc = product.upc?.toString().trim();
              const value = product.value?.toString().trim();

              return name?.includes(normalizedSearch) || upcIndex === normalizedProductData || upc === normalizedProductData || value === normalizedProductData;
            })
            .limit(100)
            .toArray();
        }

        // Handle product search results
        // if (!products || products.length === 0) {
        //   await upcPricingRule(productData, t, addDefinedProduct, setProductSearchInput, productSearchInputRef, setOptions);
        //   continue;
        // }
        if (!products || products.length === 0) {
          try {
            // 🔥 Step 1: Try syncing single product from server
            const normalizedValue = productData?.toString().trim();
            const syncId = localStorage.getItem("syncId") || uuidv4().replace(/-/g, "").toUpperCase();

            const syncedProduct = await syncSingleProductByValue(tillData, syncId, tillData.tillAccess.cwrTill.cwrTillID, normalizedValue);

            // 🔁 Step 2: Re-fetch from DB after sync
            if (syncedProduct) {
              products = await db.products
                .filter((product) => product.isactive === true)
                .filter((product) => product.productSegment !== "BG")
                .filter((product) => {
                  const name = product.name?.toLowerCase().trim();
                  const upcIndex = product.upcIndex?.toString().trim();
                  const upc = product.upc?.toString().trim();
                  const value = product.value?.toString().trim();

                  return name?.includes(productData.toLowerCase().trim()) || upcIndex === productData || upc === productData || value === productData;
                })
                .limit(100)
                .toArray();
            }
          } catch (err) {
            console.error("Single product sync failed:", err);
          }

          // ❌ Still not found → fallback (ORIGINAL behavior)
          if (!products || products.length === 0) {
            await upcPricingRule(productData, t, addDefinedProduct, setProductSearchInput, productSearchInputRef, setOptions, tillData);
            continue;
          }
        }

        // Single product found
        if (products.length === 1) {
          const product = products[0];
          if (tillLayout === 3) {
            localStorage.setItem("layoutType", 1);
            setLayoutType(1);
            const customEvent = new CustomEvent("customStorageChange", {
              detail: { key: "layoutType", newValue: 1 },
            });
            window.dispatchEvent(customEvent);
          }

          // Handle batched products
          if (product.batchedProduct === "Y" && product.batchedForSale === "Y") {
            await handleBatchedProduct(product, productData, addDefinedProduct, setBatchSetAvailable, setDisplayBatchSelection, fetchOnlineBatches);
          } else {
            const modifiedQty = product.weight >= 0 ? product.weight + 1 : 1;
            await addDefinedProduct(product, product.upc, null, null, product.sunitprice, true, modifiedQty, true, null, null, productData);
          }
        }
        // Multiple products found
        else if (products.length > 1) {
          if (posConfig?.product_search_display_mode !== "dropdown") {
            setIsProductsVisible(true);
          }
          setProductsData(products);
        }
      }
    }
  } catch (error) {
    console.error("Barcode scanning error:", error, "QR code:", data);
    await upcPricingRule(data, t, addDefinedProduct, setProductSearchInput, productSearchInputRef, setOptions, tillData);
  }
};

// Unchanged Supporting Functions (included for completeness)
// const handleBatchedProduct = async (product, data, addDefinedProduct, setBatchSetAvailable, setDisplayBatchSelection, fetchOnlineBatches) => {
//   try {
//     // Ensure product.mBatch is defined and is an array
//     if (!product?.mBatch || !Array.isArray(product.mBatch)) {
//       addDefinedProduct(product, product.upc, null, null, product.sunitprice);
//     }

//     // Find batch by barcode
//     const batchProductIndex = product.mBatch.findIndex((bp) => bp.batchno?.toLowerCase() === data.toLowerCase());

//     // Single batch with exact match
//     if (batchProductIndex >= 0 && product.multiPrice === "N") {
//       const batch = product.mBatch[batchProductIndex];
//       if (!batch?.batchno || !batch?.mBatchId || !batch?.price) {
//         console.error("Invalid batch data", batch);
//         return; // Exit if any required batch properties are missing
//       }
//       return await addDefinedProduct(product, batch.upc, batch.batchno, batch.mBatchId, batch.price, null, null, null, null, null, data);
//     }

//     // Multiple batches (or single batch — always open Select Batch drawer)
//     // const productSet = product.mBatch
//     //   .map(async (batchItem) => {
//     //     // Ensure batchItem and necessary properties are defined
//     //     if (!batchItem?.batchno || !batchItem?.mBatchId || batchItem?.price === undefined) {
//     //       console.error("Invalid batch item data", batchItem);
//     //       return null; // Skip invalid batch item
//     //     }

//     //     const modifiedProduct = { ...product };

//     //     // Tax calculation logic with valid data checks
//     //     if (modifiedProduct?.overRideTax === "Y" && batchItem?.price <= modifiedProduct?.overRideCondition) {
//     //       const originalPrice = batchItem.price - batchItem.price * (100 / (100 + modifiedProduct.taxRate));
//     //       const taxedPrice = originalPrice + (originalPrice * modifiedProduct.contraRate) / 100;

//     //       modifiedProduct.cTaxId = modifiedProduct.contraTaxId;
//     //       modifiedProduct.taxRate = modifiedProduct.contraRate;
//     //       batchItem.price = taxedPrice;
//     //     }

//     //     return createProductDefinition(modifiedProduct, batchItem);
//     //   })
//     //   .filter(Boolean); // Filter out null values

//     const productSet = product.mBatch
//       .map((batchItem) => {
//         if (!batchItem?.batchno || !batchItem?.mBatchId || batchItem?.price === undefined) {
//           console.error("Invalid batch item data", batchItem);
//           return null;
//         }

//         const modifiedProduct = { ...product };

//         if (modifiedProduct?.overRideTax === "Y" && batchItem.price <= modifiedProduct?.overRideCondition) {
//           const originalPrice = batchItem.price - batchItem.price * (100 / (100 + modifiedProduct.taxRate));

//           const taxedPrice = originalPrice + (originalPrice * modifiedProduct.contraRate) / 100;

//           modifiedProduct.cTaxId = modifiedProduct.contraTaxId;
//           modifiedProduct.taxRate = modifiedProduct.contraRate;
//           batchItem.price = taxedPrice;
//         }

//         return createProductDefinition(modifiedProduct, batchItem);
//       })
//       .filter(Boolean);

//     // Check if productSet has valid entries
//     console.log("productSet ------------>", productSet);
//     if (productSet.length > 0) {
//       setBatchSetAvailable(productSet);
//       fetchOnlineBatches(productSet);
//     }
//   } catch (error) {
//     console.error("Batched product handling error:", error);
//   }
// };

const handleBatchedProduct = async (product, data, addDefinedProduct, setBatchSetAvailable, setDisplayBatchSelection, fetchOnlineBatches) => {
  try {
    if (!product?.mBatch || !Array.isArray(product.mBatch)) {
      return addDefinedProduct(product, product.upc, null, null, product.sunitprice);
    }

    const batchProductIndex = product.mBatch.findIndex((bp) => bp.batchno?.toLowerCase() === data.toLowerCase());

    // ✅ Direct add (single batch exact match)
    if (batchProductIndex >= 0 && product.multiPrice === "N") {
      const batch = product.mBatch[batchProductIndex];

      if (!batch?.batchno || !batch?.mBatchId || batch?.price === undefined) {
        console.error("Invalid batch data", batch);
        return;
      }

      return await addDefinedProduct(product, batch.upc, batch.batchno, batch.mBatchId, batch.price, null, null, null, null, null, data);
    }

    // ✅ Build full productSet
    const productSet = product.mBatch
      .map((batchItem) => {
        if (!batchItem?.batchno || !batchItem?.mBatchId || batchItem?.price === undefined) {
          console.error("Invalid batch item data", batchItem);
          return null;
        }

        const obj = { ...product };
        const uomData = obj?.uomData || [];

        // 🔹 TAX OVERRIDE
        let batchPrice = batchItem.price;

        if (obj?.overRideTax === "Y" && batchPrice <= obj?.overRideCondition) {
          const originalPrice = batchPrice - batchPrice * (100 / (100 + obj.taxRate));

          const taxedPrice = originalPrice + (originalPrice * obj.contraRate) / 100;

          obj.cTaxId = obj.contraTaxId;
          obj.taxRate = obj.contraRate;
          batchPrice = taxedPrice;
        }

        // 🔹 UOM
        const selectedUomId = batchItem?.uomId || obj?.uomData?.[0]?.csUomId || null;

        // 🔹 PRICE LIST LOGIC
        const selectedPrice = getApplicablePrice({
          priceList: obj?.priceList,
          selectedUomId,
          sPriceListId: obj?.sPriceListId,
        });

        // 🔹 FINAL PRICE PRIORITY
        const finalPrice = batchPrice ?? selectedPrice?.pricestd ?? obj?.sunitprice ?? 0;

        // 🔹 FULL PRODUCT OBJECT (NO KEYS MISSED)
        const productDefined = {
          batchno: batchItem.batchno || null,
          description: obj.description || "",
          discount: 0,
          discountName: "",
          imageurl: obj.imageurl || "",
          isDecimal: obj.isDecimal || false,
          isManualQty: obj.isManualQty || false,
          restrictPosQtyEdit: obj.restrictPosQtyEdit || "N",
          showAlternateUomInPos: obj?.showAlternateUomInPos || "N",
          posPriceEdit: obj?.posPriceEdit || "N",
          alternateUom: obj?.alternateUom || null,
          companion: obj?.companion || "N",
          isPromoApplicable: obj.isPromoApplicable || false,
          isReturn: false,
          mBatchId: batchItem.mBatchId || null,
          mPricingruleId: null,
          name: obj.name || "",
          name2: obj.name2 || "",
          nettotal: 0,
          primaryOrderLine: null,
          productId: obj.mProductId || null,
          realPrice: finalPrice,
          listPrice: obj.slistprice || 0,
          sunitprice: finalPrice,
          originalPrice: finalPrice,
          productSegment: obj?.productSegment || "",
          returnQty: null,
          salePrice: finalPrice,
          mrpPrice: batchItem.listPrice || 0,
          stock: obj.onhandQty || 0,
          taxCategory: obj.taxCategory || "",
          taxName: obj?.taxName || "",
          taxFlag: obj?.taxFlag || "N",
          tax: obj.cTaxId || null,
          taxAmount: 0,
          taxRate: obj.taxRate || 0,
          interTaxId: obj?.interTaxId || "",
          interTaxRate: obj?.interTaxRate || 0,
          interTaxName: obj?.interTaxName || "",
          uom: selectedUomId,
          customAttributes: obj.customAttributes || {},
          preparationTime: obj?.preparationTime || "",
          printerId: obj?.printerId || "",
          productionCenterId: obj?.productionCenterId || "",
          cwrPcatalogueId: obj.cwrPcatalogueId || null,
          cwrMenuTimeslot: obj.cwrMenuTimeslot || {},
          productAliasName: obj.productAliasName || null,
          bunitName: obj?.bunitName || "",
          imageUrl: obj?.imageUrl || "",
          showAddons: obj?.showAddons || false,
          foodType: obj?.foodType || "",
          itemType: obj?.itemType || "",
          type: obj.type || "",
          addNewLine: obj.addNewLine || "N",
          newCustomAttributes: [],
          priceList: obj?.priceList || [],
          selectedAddons: [],
          uom_name: obj.uomName || "",
          isDecimalQty: uomData?.[0]?.decimal === "Y" || false,
          isQtyDesimal: uomData?.[0]?.stdprecision || 2,
          upc: batchItem.upc || null,
          value: obj.value || null,
          weight: 0,
          shortDescription: obj.shortDescription || "",
          hsncode: obj.hsncode || null,
          csBunitId: obj.csBunitId || null,
          mProductCategoryId: obj.mProductCategoryId || null,
          productManufacturerId: obj.productManufacturerId || null,
          productBrandId: obj.productBrandId || null,
          productBrandName: obj?.productBrandName || null,
          batchedProduct: obj.batchedProduct || "",
          batchedForSale: obj.batchedForSale || "",
          batchedForStock: obj.batchedForStock || "",
          multiPrice: obj.multiPrice || "",
          shelfLife: obj.shelfLife || "",
          stdTax: finalPrice * (1 + (obj?.taxRate || 0) / 100),
          posPriceEdit: obj?.posPriceEdit || "N",
        };

        return productDefined;
      })
      .filter(Boolean);

    console.log("productSet ------------>", productSet);

    if (productSet.length > 0) {
      setBatchSetAvailable(productSet);
      fetchOnlineBatches(productSet);
    }
  } catch (error) {
    console.error("Batched product handling error:", error);
  }
};

const createProductDefinition = (product, batchItem) => ({
  batchno: batchItem?.batchno ?? "",
  description: product?.description ?? "",
  discount: 0,
  discountName: "",
  imageurl: product?.imageurl ?? "",
  isDecimal: product?.isDecimal ?? false,
  isManualQty: product?.isManualQty ?? false,
  restrictPosQtyEdit: product?.restrictPosQtyEdit || "N",
  showAlternateUomInPos: product?.showAlternateUomInPos || "N",
  posPriceEdit: product?.posPriceEdit || "N",
  interTaxId: product?.interTaxId || "",
  interTaxRate: product?.interTaxRate || 0,
  interTaxName: product?.interTaxName || "",
  alternateUom: product?.alternateUom || null,
  companion: product?.companion || "N",
  isPromoApplicable: product?.isPromoApplicable ?? false,
  isReturn: false,
  mBatchId: batchItem?.mBatchId ?? null,
  mPricingruleId: null,
  name: product?.name ?? "",
  nettotal: 0,
  primaryOrderLine: null,
  productId: product?.mProductId ?? "",
  realPrice: product?.sunitprice ?? 0,
  listPrice: product?.slistprice ?? 0,
  sunitprice: product?.sunitprice ?? 0,
  originalPrice: product?.sunitprice ?? 0,
  productSegment: product.productSegment || "",
  returnQty: null,
  salePrice: product?.sunitprice ?? 0,
  mrpPrice: batchItem?.listPrice ?? 0,
  stock: product?.onhandQty ?? 0,
  taxCategory: product?.taxCategory ?? "",
  taxName: product?.taxName ?? "",
  taxFlag: product?.taxFlag ?? "N",
  tax: product?.cTaxId ?? 0,
  taxAmount: 0,
  taxRate: product?.taxRate ?? 0,
  uom: product?.csUomId ?? "",
  uom_name: product?.uomName ?? "",
  isDecimalQty: product?.uomData?.[0]?.decimal === "Y" ?? false,
  isQtyDesimal: product?.uomData?.[0]?.stdprecision ?? 2,
  upc: batchItem?.upc ?? "",
  value: product?.value ?? 0,
  weight: 0,
  shortDescription: product?.shortDescription ?? "",
  hsncode: product?.hsncode ?? "",
  csBunitId: product?.csBunitId ?? "",
  mProductCategoryId: product?.mProductCategoryId ?? "",
  productManufacturerId: product?.productManufacturerId ?? "",
  productBrandId: product?.productBrandId ?? "",
  productBrandName: product?.productBrandName ?? "",
  batchedProduct: product?.batchedProduct ?? false,
  batchedForSale: product?.batchedForSale ?? false,
  batchedForStock: product?.batchedForStock ?? false,
  multiPrice: product?.multiPrice ?? "N",
  shelfLife: product?.shelfLife ?? "",
  addNewLine: product?.addNewLine || "N",
});

const getProduct = async (
  formula,
  newData,
  tillData,
  data,
  tillLayout,
  addDefinedProduct,
  setBatchSetAvailable,
  setDisplayBatchSelection,
  setLayoutType,
  setIsProductsVisible,
  setProductsData,
  setSelectedProductInCart,
  setProductSearchInput,
  productSearchInputRef,
  config,
  authHeaders,
  setOptions,
  fetchOnlineBatches
) => {
  let productValue =
    typeof newData === "string" && newData.includes("productcode:")
      ? newData.match(/productcode:([^,]+)/)?.[1]?.trim()
      : config.barcodeLength === newData.length
        ? newData.substr(Number(formula.property?.["product.value"]?.position ?? 0) - 1, Number(formula.property?.["product.value"]?.length ?? 0))
        : newData;

  let batchno = typeof newData === "string" && newData.includes("batchno:") ? newData.match(/batchno:([^,]+)/)?.[1]?.trim() : null;

  productValue = config?.delimiter ? productValue.replace(/^0+/, "") : productValue;

  const operators = ["+", "-", "/", "*"];
  const operatorFunctions = {
    "+": (a, b) => a + b,
    "-": (a, b) => a - b,
    "*": (a, b) => a * b,
    "/": (a, b) => a / b,
  };
  await db.products
    .where("value")
    .equalsIgnoreCase(productValue)
    .and((product) => product.isactive === true)
    .and((product) => product.productSegment !== "BG")
    .toArray()
    .then(async (product) => {
      const uomData = product[0]?.uomData[0];
      let orderNo = "";
      const currenciesList = tillData.tillAccess.csBunit.currencies;
      let scanFlag = false;

      let cartlineUnitprice;
      let cartlineTotal;
      let cartlineQty;
      if (formula.property) {
        if (formula?.property["cartline.unitprice"] !== undefined) {
          if (typeof formula.property["cartline.unitprice"] === "number") {
            cartlineUnitprice = formula.property["cartline.unitprice"];
          } else if (typeof formula.property["cartline.unitprice"] === "string") {
            const foundOperator = operators.find((op) => formula.property["cartline.unitprice"].includes(op));
            const splitArr = formula.property["cartline.unitprice"].split(foundOperator);
            let unitpriceArr = splitArr.map((splitItem) => {
              let value;
              if (splitItem.includes("cartline")) {
                if (splitItem.includes("qty")) {
                  if (typeof formula.property["cartline.qty"] === "number") {
                    value = formula.property["cartline.qty"];
                  } else if (typeof formula.property["cartline.qty"] === "object") {
                    value = parseFloat(
                      (
                        Number(newData.substr(Number(formula.property["cartline.qty"]?.position - 1), Number(formula.property["cartline.qty"]?.length))) /
                        (uomData && uomData?.decimal === "Y" ? Math.pow(10, uomData?.stdprecision) : 1)
                      ).toFixed(uomData && uomData?.decimal === "Y" ? uomData?.stdprecision : 3)
                    );
                  }
                } else if (splitItem.includes("total")) {
                  if (typeof formula.property["cartline.total"] === "number") {
                    value = formula.property["cartline.total"];
                  } else if (typeof formula.property["cartline.total"] === "object") {
                    value = parseFloat(
                      (
                        Number(newData.substr(Number(formula.property["cartline.total"]?.position - 1), Number(formula.property["cartline.total"]?.length))) /
                        (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
                      ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
                    );
                  }
                } else if (splitItem.includes("unitprice")) {
                  if (typeof formula.property["cartline.unitprice"] === "number") {
                    value = formula.property["cartline.unitprice"];
                  } else if (typeof formula.property["cartline.unitprice"] === "object") {
                    value = parseFloat(
                      (
                        Number(newData.substr(Number(formula.property["cartline.unitprice"]?.position - 1), Number(formula.property["cartline.unitprice"]?.length))) /
                        (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
                      ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
                    );
                  }
                }
              } else {
                value = product[0].sunitprice;
              }
              return value;
            });
            cartlineUnitprice = operatorFunctions[foundOperator](unitpriceArr[0], unitpriceArr[1]);
          } else {
            cartlineUnitprice = parseFloat(
              (
                Number(newData.substr(Number(formula.property["cartline.unitprice"]?.position - 1), Number(formula.property["cartline.unitprice"]?.length))) /
                (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
              ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
            );
          }
        }

        if (formula?.property["cartline.total"] !== undefined) {
          if (typeof formula.property["cartline.total"] === "number") {
            cartlineTotal = formula.property["cartline.total"];
          } else if (typeof formula.property["cartline.total"] === "string") {
            const foundOperator = operators.find((op) => formula.property["cartline.total"].includes(op));
            const splitArr = formula.property["cartline.total"].split(foundOperator);
            let totalArr = splitArr.map((splitItem) => {
              let value;
              if (splitItem.includes("cartline")) {
                if (splitItem.includes("qty")) {
                  if (typeof formula.property["cartline.qty"] === "number") {
                    value = formula.property["cartline.qty"];
                  } else if (typeof formula.property["cartline.qty"] === "object") {
                    value = parseFloat(
                      (
                        Number(newData.substr(Number(formula.property["cartline.qty"]?.position - 1), Number(formula.property["cartline.qty"]?.length))) /
                        (uomData && uomData?.decimal === "Y" ? Math.pow(10, uomData?.stdprecision) : 1)
                      ).toFixed(uomData && uomData?.decimal === "Y" ? uomData?.stdprecision : 3)
                    );
                  }
                } else if (splitItem.includes("total")) {
                  if (typeof formula.property["cartline.total"] === "number") {
                    value = formula.property["cartline.total"];
                  } else if (typeof formula.property["cartline.total"] === "object") {
                    value = parseFloat(
                      (
                        Number(newData.substr(Number(formula.property["cartline.total"]?.position - 1), Number(formula.property["cartline.total"]?.length))) /
                        (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
                      ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
                    );
                  }
                } else if (splitItem.includes("unitprice")) {
                  if (typeof formula.property["cartline.unitprice"] === "number") {
                    value = formula.property["cartline.unitprice"];
                  } else if (typeof formula.property["cartline.unitprice"] === "object") {
                    value = parseFloat(
                      (
                        Number(newData.substr(Number(formula.property["cartline.unitprice"]?.position - 1), Number(formula.property["cartline.unitprice"]?.length))) /
                        (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
                      ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
                    );
                  }
                }
              } else {
                value = product[0]?.sunitprice || 0;
              }
              return value;
            });
            cartlineTotal = operatorFunctions[foundOperator](totalArr[0], totalArr[1]);
          } else {
            const flag = process.env.REACT_APP_OFC_SCAN_MODE == "true" ? true : false;
            if (flag) {
              let propertyTotalprice = formula.property["cartline.total"];
              let totalPrice = newData.substr(Number(propertyTotalprice.position - 1), Number(propertyTotalprice.length));
              cartlineTotal = parseFloat(totalPrice.slice(0, -3) + "." + totalPrice.slice(-3));
            } else {
              cartlineTotal = parseFloat(
                (
                  Number(newData.substr(Number(formula.property["cartline.total"]?.position - 1), Number(formula.property["cartline.total"]?.length))) /
                  (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
                ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
              );
            }
          }
        }

        if (formula?.property["cartline.qty"] !== undefined) {
          if (typeof formula.property["cartline.qty"] === "number") {
            cartlineQty = formula.property["cartline.qty"];
          } else if (typeof formula.property["cartline.qty"] === "string") {
            const foundOperator = operators.find((op) => formula.property["cartline.qty"].includes(op));
            const splitArr = formula.property["cartline.qty"].split(foundOperator);
            let qtyArr = splitArr.map((splitItem) => {
              let value;
              if (splitItem.includes("cartline")) {
                if (splitItem.includes("qty")) {
                  if (typeof formula.property["cartline.qty"] === "number") {
                    value = formula.property["cartline.qty"];
                  } else if (typeof formula.property["cartline.qty"] === "object") {
                    value = parseFloat(
                      (
                        Number(newData.substr(Number(formula.property["cartline.qty"]?.position - 1), Number(formula.property["cartline.qty"]?.length))) /
                        (uomData && uomData?.decimal === "Y" ? Math.pow(10, uomData?.stdprecision) : 1)
                      ).toFixed(uomData && uomData?.decimal === "Y" ? uomData?.stdprecision : 3)
                    );
                  }
                } else if (splitItem.includes("total")) {
                  if (typeof formula.property["cartline.total"] === "number") {
                    value = formula.property["cartline.total"];
                  } else if (typeof formula.property["cartline.total"] === "object") {
                    value = parseFloat(
                      (
                        Number(newData.substr(Number(formula.property["cartline.total"]?.position - 1), Number(formula.property["cartline.total"]?.length))) /
                        (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
                      ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
                    );
                  }
                } else if (splitItem.includes("unitprice")) {
                  if (typeof formula.property["cartline.unitprice"] === "number") {
                    value = formula.property["cartline.unitprice"];
                  } else if (typeof formula.property["cartline.unitprice"] === "object") {
                    value = parseFloat(
                      (
                        Number(newData.substr(Number(formula.property["cartline.unitprice"]?.position - 1), Number(formula.property["cartline.unitprice"]?.length))) /
                        (currenciesList[0]?.stdPrecision ? Math.pow(10, currenciesList[0].stdPrecision) : 100)
                      ).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2)
                    );
                  }
                }
              } else if (splitItem.includes("product")) {
                if (splitItem.includes("unitprice")) {
                  value = product[0]?.sunitprice;
                } else if (splitItem.includes("nettotal")) {
                  value = cartlineTotal;
                }
              } else {
                value = product[0].sunitprice;
              }
              return value;
            });
            const flag = process.env.REACT_APP_OFC_SCAN_MODE == "true" ? true : false;
            if (flag) {
              cartlineQty = cartlineTotal / product[0].sunitprice >= 0 ? cartlineTotal / product[0].sunitprice : 1;
              let multipliedValue = cartlineQty * product[0].sunitprice * 100;
              let roundedValue = Math.floor(multipliedValue);
              cartlineTotal =
                Number(Number(roundedValue / 100).toFixed(product[0].uomData[0]?.stdprecision > 0 ? product[0].uomData[0]?.stdprecision : 2)) >= 0
                  ? Number(Number(roundedValue / 100).toFixed(product[0].uomData[0]?.stdprecision > 0 ? product[0].uomData[0]?.stdprecision : 2))
                  : product[0].sunitprice;
              cartlineQty = cartlineQty?.toFixed(uomData && uomData?.decimal === "Y" ? uomData?.stdprecision : 3);
            } else {
              cartlineQty = operatorFunctions[foundOperator](qtyArr[0], qtyArr[1]);
            }
          } else if (typeof formula.property["cartline.qty"] === "object") {
            cartlineQty = parseFloat(
              (
                Number(newData.substr(Number(formula.property["cartline.qty"]?.position - 1), Number(formula.property["cartline.qty"]?.length))) /
                (uomData && uomData?.decimal === "Y" ? Math.pow(10, uomData?.stdprecision) : 1)
              ).toFixed(uomData && uomData?.decimal === "Y" ? uomData?.stdprecision : 3)
            );
          }
        }

        if (formula?.property["production.orderNo"] !== undefined) {
          orderNo = newData.substr(Number(formula.property["production.orderNo"]?.position - 1), Number(formula.property["production.orderNo"]?.length));
        }

        if (formula?.property["product.unitprice"] !== undefined) {
          if (formula.property["product.unitprice"]?.type === "event") {
            const workflowRules = await db.POSWorkFlowRules.toArray();
            // const approvers = await db.approvers.toArray();

            if (workflowRules && workflowRules.length > 0) {
              await Promise.all(
                workflowRules.map(async (res) => {
                  if (res.eventId === "productPriceOnScan") {
                    const serverUrl = process.env.REACT_APP_serverUrl;
                    const CWCoreServicesUrl = process.env.REACT_APP_genericUrl;

                    if (res.apiSource === "APB") {
                      const value = { orderno: orderNo, value: productValue };
                      const newStringifiedFields = JSON.stringify(value).replace(/\\"/g, '\\"');
                      const newStringRequest = JSON.stringify(newStringifiedFields);
                      const apiBuilder = {
                        query: `mutation { executeAPIBuilder(apiBuilderId:"${res.apiEndPoint}", params: ${newStringRequest})} `,
                      };
                      const headers = {
                        "Content-Type": "application/json",
                        Authorization: `${authHeaders?.access_token}`,
                      };

                      const apiBuilderResponse = await productPriceOnScan(apiBuilder);

                      if (apiBuilderResponse.data.data.executeAPIBuilder.length > 0) {
                        const response = JSON.parse(apiBuilderResponse.data.data.executeAPIBuilder);
                        product[0].mBatchId = response?.length > 0 ? response[0]?.m_batch_id : null;
                        product[0].batchno = response?.length > 0 ? response[0]?.batch_no : null;
                        cartlineUnitprice = parseFloat(response?.length > 0 ? response[0].sale_price.toFixed(currenciesList[0].stdPrecision || 2) : 0);
                      }
                    }
                  }
                })
              );
            }
          }
        }
      }
      if (cartlineUnitprice || cartlineTotal) {
        scanFlag = true;
      }

      if (product.length <= 0) {
        let chackBarcodeFlag = true;
        await barcodeScaner(
          data,
          tillData,
          tillLayout,
          addDefinedProduct,
          setBatchSetAvailable,
          setDisplayBatchSelection,
          setLayoutType,
          setIsProductsVisible,
          setProductsData,
          chackBarcodeFlag,
          setSelectedProductInCart,
          setProductSearchInput,
          productSearchInputRef,
          null,
          null,
          setOptions,
          fetchOnlineBatches
        );
      } else {
        product[0].taxFlag = formula?.calculateTax || "N";
        if (product[0].taxFlag === "Y") {
          cartlineUnitprice = cartlineUnitprice ? cartlineUnitprice : product[0]?.sunitprice;
          let taxValue = (cartlineUnitprice * (product[0].taxRate / 100)) / (1 + product[0].taxRate / 100);
          cartlineUnitprice = parseFloat((cartlineUnitprice - taxValue).toFixed(currenciesList[0].stdPrecision ? currenciesList[0].stdPrecision : 2));
          product[0].sunitprice = cartlineUnitprice;
        }
        if (batchno) {
          product[0].batchno = batchno;
        }

        await addDefinedProduct(
          product[0],
          product[0].upc,
          product[0]?.batchno || null,
          product[0]?.mBatchId || null,
          cartlineUnitprice || product[0].sunitprice,
          true,
          cartlineQty || 1,
          false,
          cartlineTotal,
          scanFlag,
          data
        );
      }
    });
};

const barcodeScanFromConfig = async (
  data,
  tillData,
  tillLayout,
  addDefinedProduct,
  setBatchSetAvailable,
  setDisplayBatchSelection,
  setLayoutType,
  setIsProductsVisible,
  setProductsData,
  setSelectedProductInCart,
  setProductSearchInput,
  productSearchInputRef,
  authHeaders,
  setOptions,
  fetchOnlineBatches
) => {
  // Helper function to process a product with a config
  const processSingleProduct = async (config, productData) => {
    let formula = JSON.parse(config.formula);
    formula.calculateTax = config.calculateTax || "N";
    await getProduct(
      formula,
      productData,
      tillData,
      productData,
      tillLayout,
      addDefinedProduct,
      setBatchSetAvailable,
      setDisplayBatchSelection,
      setLayoutType,
      setIsProductsVisible,
      setProductsData,
      setSelectedProductInCart,
      setProductSearchInput,
      productSearchInputRef,
      config,
      authHeaders,
      setOptions,
      fetchOnlineBatches
    );
  };

  let newData = data.toString();
  let posConfig = tillData.posScanConfigs.filter((item) => item.formula !== null && item.scanTrxType === "PR");
  let productsToProcess = [];

  // Determine products to process based on config
  // if (posConfig?.length === 1) {
  //   let posConfigItem = posConfig?.filter((item) => newData.startsWith(item.startsWith));
  //   productsToProcess.push({ config: posConfigItem[0], data: newData });
  // } else {
  let posConfigItem = posConfig?.filter((item) => newData.startsWith(item.startsWith));
  if (posConfigItem.length > 0) {
    let config = posConfigItem[0];
    productsToProcess.push({ config: config, data: newData });
  } else if (newData.includes("productcode:") && newData.includes("batchno:")) {
    let config = posConfig?.filter((item) => item.formula !== null && item.scanTrxType === "PR" && item?.qrCode === "Y")[0];
    productsToProcess.push({ config: config, data: newData });
  }
  // }

  // Process all collected products using `for...of`
  if (productsToProcess.length > 0) {
    for (const { config, data } of productsToProcess) {
      await processSingleProduct(config, data);
    }
  } else {
    let chackBarcodeFlag = true;
    await barcodeScaner(
      data,
      tillData,
      tillLayout,
      addDefinedProduct,
      setBatchSetAvailable,
      setDisplayBatchSelection,
      setLayoutType,
      setIsProductsVisible,
      setProductsData,
      chackBarcodeFlag,
      setSelectedProductInCart,
      setProductSearchInput,
      productSearchInputRef,
      productSearchInputRef,
      authHeaders,
      setOptions,
      fetchOnlineBatches
    );
  }
};

const rfidScaner = (
  data,
  tillData,
  tillLayout,
  addDefinedProduct,
  setBatchSetAvailable,
  setDisplayBatchSelection,
  setLayoutType,
  setIsProductsVisible,
  setProductsData,
  chackBarcodeFlag,
  setSelectedProductInCart,
  setProductSearchInput,
  productSearchInputRef,
  cart,
  authHeaders,
  setOptions,
  fetchOnlineBatches
) => {
  db.rfidData
    .where("tag_value")
    .equalsIgnoreCase(data)
    .toArray()
    .then(async (item) => {
      if (item.length > 0) {
        const scannedProductCode = item[0].product_code;
        const existingIndex = cart?.items?.findIndex((item) => item.value === scannedProductCode);
        if (existingIndex === -1) {
          await barcodeScaner(
            item[0].product_code,
            tillData,
            tillLayout,
            addDefinedProduct,
            setBatchSetAvailable,
            setDisplayBatchSelection,
            setLayoutType,
            setIsProductsVisible,
            setProductsData,
            chackBarcodeFlag,
            setSelectedProductInCart,
            setProductSearchInput,
            productSearchInputRef,
            cart,
            authHeaders,
            setOptions,
            fetchOnlineBatches
          );
          db.rfidData.update(item[0].tag_value, { tag_status: "SO" });
          if (tillLayout === 3) {
            localStorage.setItem("layoutType", 1);
            setLayoutType(1);
            const customEvent = new CustomEvent("customStorageChange", {
              detail: { key: "layoutType", newValue: 1 },
            });
            window.dispatchEvent(customEvent);
          }
        } else {
          message.info(`${messages.info.already_scanned}`);
        }
      }
    });
};

const upcPricingRule = async (data, t, addDefinedProduct, setProductSearchInput, productSearchInputRef, setOptions, tillData) => {
  const pr = await db.pricingRules.toArray();
  let productFlag = false;

  for (const ele of pr) {
    if (ele.upc === data) {
      const pro = await db.products
        .where("mProductId")
        .equalsIgnoreCase(ele.mPricingXProducts[0].mProductId)
        .and((product) => product.isactive === true)
        .and((product) => product.productSegment !== "BG")
        .toArray();

      let productObj = pro[0];

      // 🔥 SYNC IF NOT FOUND (USING mProductId)
      if (!productObj && ele?.mPricingXProducts?.[0]?.mProductId) {
        try {
          const normalizedValue = ele.mPricingXProducts[0].mProductId?.toString().trim();

          console.log("Syncing pricingRule product using productId:", normalizedValue);

          const syncId = localStorage.getItem("syncId") || uuidv4().replace(/-/g, "").toUpperCase();

          await syncSingleProductByValue(tillData, syncId, tillData?.tillAccess?.cwrTill?.cwrTillID, normalizedValue);

          // 🔁 Re-fetch after sync
          const productAfterSync = await db.products
            .where("mProductId")
            .equalsIgnoreCase(ele.mPricingXProducts[0].mProductId)
            .and((product) => product.isactive === true)
            .and((product) => product.productSegment !== "BG")
            .toArray();

          productObj = productAfterSync[0];
        } catch (err) {
          console.error("PricingRule product sync failed:", err);
        }
      }

      // ✅ CONTINUE NORMAL FLOW
      if (productObj) {
        productObj.upcPricingRule = ele.upc;
        productFlag = true;

        await addDefinedProduct(productObj, productObj.upc, null, null, productObj.sunitprice, true, ele.mPricingXProducts[0].quantity, null, null, null, data);
      }

      if (pro.length > 0) {
        pro[0].upcPricingRule = ele.upc;
        productFlag = true;
        await addDefinedProduct(pro[0], pro[0].upc, null, null, pro[0].sunitprice, true, ele.mPricingXProducts[0].quantity, null, null, null, data);
      }
    }
  }

  if (!productFlag) {
    const posConfig = JSON.parse(localStorage.getItem("posConfig"));
    if (posConfig?.errorPopupAutoClose === "Y") {
      Modal.info({
        icon: null,
        okButtonProps: { style: { display: "none" } },
        okText: "Go Back",
        okButtonProps: { style: { display: "inline-block" } },
        content: (
          <div
            style={{
              fontSize: "18px",
              fontWeight: "500",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              paddingLeft: 0,
              fontSize: "1vw",
            }}
          >
            <img src={NotFoundImg} alt="Not Found" style={{ width: "120px", height: "100px", marginBottom: "5px", marginTop: "10px" }} />
            <p style={{ margin: "5px 0", fontSize: "2em", fontWeight: "600", color: "#0F0718" }}>Product Not Found</p>
            <hr style={{ width: "70%", color: "rgba(146,144,152,0.5" }} />
            <p style={{ color: "#0F0718", fontWeight: 400, fontSize: "1.25em", padding: "15px 15px 0 15px" }}>
              The scanned QR code ({data}) is not in the system. Please check the QR code or enter the item manually.
            </p>
          </div>
        ),
        style: {
          textAlign: "center",
          height: "50vh",
          width: "50%",
        },
        bodyStyle: {
          padding: "0",
        },
        closable: false,
        onOk: null,
      });

      setTimeout(() => {
        Modal.destroyAll();
      }, 1500);
    } else {
      Modal.info({
        icon: null,
        okText: "Ok",
        okButtonProps: { style: { display: "inline-block" } },
        content: (
          <div
            style={{
              fontSize: "18px",
              fontWeight: "500",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              paddingLeft: 0,
              fontSize: "1vw",
            }}
          >
            <img src={NotFoundImg} alt="Not Found" style={{ width: "120px", height: "100px" }} />
            <p style={{ margin: "5px 0", fontSize: "1.5em", fontWeight: "600", color: "#0F0718" }}>{data}</p>
            <p style={{ margin: "5px 0", fontSize: "2em", fontWeight: "600", color: "#0F0718" }}>Product Not Found</p>
            <hr style={{ width: "70%", color: "rgba(146,144,152,0.5" }} />
            <p style={{ color: "#0F0718", fontWeight: 400, fontSize: "1.25em", padding: "15px 15px 0 15px" }}>
              The scanned product is not in the system. Please check the barcode or enter the item manually.
            </p>
          </div>
        ),
        style: {
          textAlign: "center",
          height: "50vh",
          width: "50%",
        },
        closable: false,
      });
    }
  }
  setProductSearchInput("");
  setOptions([]);
  if (productSearchInputRef?.current) {
    productSearchInputRef?.current?.clearInput();
  }
};
